export type SettingsGreetingsListPageTabsKeys = 'active' | 'inactive'
export const SettingsGreetingsListPageTabsKeysEnum: Record<
  SettingsGreetingsListPageTabsKeys,
  SettingsGreetingsListPageTabsKeys
> = {
  active: 'active',
  inactive: 'inactive',
} as const
export const DEFAULT_SETTINGS_GREETINGS_LIST_PAGE_TAB: SettingsGreetingsListPageTabsKeys =
  'inactive'
export const SettingsGreetingsListPageTabsKeysArray: SettingsGreetingsListPageTabsKeys[] =
  ['active', 'inactive']
